// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__cTjr2","open-menu":"Sidebar_open-menu__DCFIm","ham_icon_container":"Sidebar_ham_icon_container__FIfjw"};